<script lang="ts" setup>
import type { PropType } from 'vue';

const props = defineProps({
  item: {
    type: Object as PropType<Record<string, any>>,
    default: () => ({}),
  },

  descriptionList: {
    type: Array as PropType<Record<string, any>[]>,
    default: () => [],
  },
});

const getTruncateClass = (item: Record<string, any>) => {
  if (item.projectCode && item.externalLink) {
    return 'max-w-70%';
  }

  if (item.projectCode || item.externalLink) {
    return 'max-w-80%';
  }

  return 'max-w-100%';
};
</script>

<template>
  <div
    class="group box-border h-320px w-432px border border-[rgba(154,158,166,0.2)] rounded-4px border-solid bg-[rgba(45,45,45,0.02)] p-32px <2xl:h-304px <2xl:w-384px <2xl:p-24px hover:bg-white hover:shadow-[0_0_16px_0_rgba(0,0,0,0.04)]"
  >
    <template v-if="props.item.id">
      <div class="h-36 flex-y-center text-24 text-#2d2d2d">
        <img
          v-if="props.item.cardLogo"
          class="lazyload h-36 w-130 object-cover"
          :data-src="props.item.cardLogo"
        >

        <span
          v-else
          class="mb-4 inline-block h-36 truncate text-24 text-#2d2d2d font-medium leading-36 <2xl:max-w-60% group-hover:text-#1180ff"
          :class="getTruncateClass(props.item)"
          :title="props.item.title"
        >
          {{ props.item.title }}
        </span>

        <a
          v-if="props.item.projectCode"
          :href="props.item.projectCode"
          target="_blank"
          class="ml-16 inline-block h-24 text-14 text-#1180ff leading-24"
        >
          {{ $t('projects.index.codeCabin2') }}
        </a>
        <a
          v-if="props.item.externalLink"
          :href="props.item.externalLink"
          target="_blank"
          class="ml-16 inline-block h-24 text-14 text-#1180ff leading-24"
        >
          {{ $t('projects.index.website2') }}
        </a>
      </div>

      <div class="h-160 overflow-y-auto">
        <div
          class="mt-8 flex text-16 text-#2d2d2d leading-24"
          v-show="props.item[piece.content]"
          v-for="piece in descriptionList"
          :key="piece.title"
          :title="props.item[piece.content]"
        >
          <span class="mr-8 flex-shrink-0">{{ piece.title }}:</span>
          <span class="truncate">{{ props.item[piece.content] }}</span>
        </div>
      </div>

      <a
        :href="props.item.projectDownload"
        class="mt-28 inline-block border border-#1180ff rounded-4 border-solid px-20 py-7 text-center text-14 text-#1180ff no-underline group-hover:border-unset group-hover:bg-#1180ff group-hover:text-white"
        target="_blank"
        v-if="props.item.projectDownload"
      >
        {{ $t('projects.index.details2') }}
      </a>
    </template>
  </div>
</template>
